import { AxiosInstance } from 'axios';
import http from '../../../../http';

export interface CompletedCheckoutSession {
  productName: string;
  creatorName: string;
  currencyCode: string;
  pricePerMonth: number;
  orderTotal: number;
  studentEmail: string;
  firstPaymentInCents: number;
  projectId: string;
}

function getCompletedOrder(http: AxiosInstance) {
  return async function completeCheckout(sessionId: string): Promise<CompletedCheckoutSession> {
    const { data } = await http.get(`/checkout-full/${sessionId}/completed`);
    return data;
  };
}

export default getCompletedOrder(http);
